module.exports = __webpack_public_path__ + "public/files/img/logo.7a0bb615.png";